import React from 'react';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import { Redirect } from 'react-router-dom';
import Queued from './containers/Queued';
import Jobs from './containers/Jobs';
import Carrier from './containers/Carrier';
import Vehicle from './containers/VehicleSection';
import Docs from './containers/Docs';
import { Settings } from './containers/Settings';
import { PostalCodes } from './containers/PostalCodes';
import EditShipperOrder from 'modules/shipper-order/Edit';
import ViewShipperOrder from 'modules/shipper-order/View';
import NewShipperOrderModal from 'modules/shipper-order/NewModal';
import RecurringOrderDetail from 'modules/recurring-orders/Detail';
import DriverPositionSection from 'modules/driver-position/Section';
import TasksSection from 'modules/tasks';
import PreferencesManager from 'modules/preferences-manager';
import ShipperContracts from 'modules/shipper-contracts';
import { PrebookingSection } from 'modules/prebookings';
import FleetSection from 'modules/fleet/section';
import ShippersSection from 'modules/shippers';
import EmergenciesSection from 'modules/emergencies';
import DelegationModule from 'modules/delegation';
import { NetworkModule } from 'modules/network';
import { POISection, POIDebugger } from 'modules/point-of-interest';
import User from './containers/Users';
import config from './config';
import { constants } from 'redux/modules/client-config/selectors';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';
import UserManagementModule from 'modules/user-management';
import Contracts from 'modules/pricing/contracts';
import { LastMileModule } from 'modules/last-mile';
import CopilotModule from 'modules/copilot';
import { PricingConsoleModule } from 'modules/pricing-console';

const BASE_ROUTE = config.BASE_ROUTE;
export const defaultRoute = `${BASE_ROUTE}${getTenantPreLoginConfig().login_redirect}`;

export const UserIsAuthenticated = connectedRouterRedirect({
  authenticatedSelector: (state) => !!state.user,
  wrapperDisplayName: 'UserIsAuthenticated',
  redirectPath: `${BASE_ROUTE}login`,
});

//base routes
const Base = () => <Redirect to={defaultRoute} />;

export const routes = [
  {
    path: BASE_ROUTE,
    component: UserIsAuthenticated(Base),
    exact: true,
  },
  {
    path: `${BASE_ROUTE}recurring-orders/:id`,
    component: UserIsAuthenticated(RecurringOrderDetail),
  },
  {
    path: `${BASE_ROUTE}edit_shipper_order/:id`,
    component: UserIsAuthenticated(EditShipperOrder),
    requiredFlag: constants.NEW_SHIPPER_ORDER,
  },
  {
    path: `${BASE_ROUTE}view_shipper_order/:id`,
    component: UserIsAuthenticated(ViewShipperOrder),
  },
  {
    path: `${BASE_ROUTE}new_shipper_order`,
    component: UserIsAuthenticated(NewShipperOrderModal),
    requiredFlag: constants.NEW_SHIPPER_ORDER,
  },
  {
    path: `${BASE_ROUTE}queued`,
    component: UserIsAuthenticated(Queued),
    requiredFlag: constants.QUEUED_TAB,
  },
  {
    path: `${BASE_ROUTE}jobs`,
    component: UserIsAuthenticated(Jobs),
    requiredFlag: constants.JOBS_TAB,
  },
  {
    path: `${BASE_ROUTE}shipper`,
    component: UserIsAuthenticated(ShippersSection),
    requiredFlag: constants.SHIPPERS_TAB,
  },
  {
    path: `${BASE_ROUTE}carrier`,
    component: UserIsAuthenticated(Carrier),
    requiredFlag: constants.CARRIERS_TAB,
  },
  {
    path: `${BASE_ROUTE}vehicle`,
    component: UserIsAuthenticated(Vehicle),
    requiredFlag: constants.VEHICLES_TAB,
  },
  {
    path: `${BASE_ROUTE}user`,
    component: UserIsAuthenticated(User),
    requiredFlag: constants.USERS_SECTION,
  },
  {
    path: `${BASE_ROUTE}settings`,
    component: UserIsAuthenticated(Settings),
    requiredFlag: constants.SETTINGS_TAB,
  },
  {
    path: `${BASE_ROUTE}postal-codes`,
    component: UserIsAuthenticated(PostalCodes),
    requiredFlag: constants.POSTAL_CODES_SECTION,
  },
  {
    path: `${BASE_ROUTE}driver-positions`,
    component: UserIsAuthenticated(DriverPositionSection),
    requiredFlag: constants.DRIVER_POSITION_SECTION,
  },
  {
    path: `${BASE_ROUTE}tasks`,
    component: UserIsAuthenticated(TasksSection),
    requiredFlag: constants.TASKS_TAB,
  },
  {
    path: `${BASE_ROUTE}preferences`,
    component: UserIsAuthenticated(PreferencesManager),
    requiredFlag: constants.PREFERENCES_SECTION,
  },
  {
    path: `${BASE_ROUTE}shipper-contracts/:shipperId?`,
    component: UserIsAuthenticated(ShipperContracts),
    requiredFlag: constants.SHIPPERS_CONTRACTS_SECTION,
  },
  {
    path: `${BASE_ROUTE}contracts`,
    component: UserIsAuthenticated(Contracts),
    requiredFlag: constants.SHIPPERS_CONTRACTS_SECTION,
  },
  {
    path: `${BASE_ROUTE}docs`,
    component: UserIsAuthenticated(Docs),
    requiredFlag: constants.DOCS_TAB,
  },
  {
    path: `${BASE_ROUTE}prebookings`,
    component: UserIsAuthenticated(PrebookingSection),
    requiredFlag: constants.PREBOOKINGS_TAB,
  },
  {
    path: `${BASE_ROUTE}poi`,
    component: UserIsAuthenticated(POISection),
    requiredFlag: constants.POI_TAB,
  },
  {
    path: `${BASE_ROUTE}poi-debugger`,
    component: UserIsAuthenticated(POIDebugger),
    requiredFlag: constants.POI_TAB,
  },
  {
    path: `${BASE_ROUTE}fleet`,
    component: UserIsAuthenticated(FleetSection),
    requiredFlag: constants.FLEET_TAB,
  },
  {
    path: `${BASE_ROUTE}emergencies`,
    component: UserIsAuthenticated(EmergenciesSection),
    requiredFlag: constants.EMERGENCIES_TAB,
  },
  {
    path: `${BASE_ROUTE}delegation`,
    component: UserIsAuthenticated(DelegationModule),
    requiredFlag: constants.DELEGATION_TAB,
  },
  {
    path: `${BASE_ROUTE}user-management`,
    component: UserIsAuthenticated(UserManagementModule),
    requiredFlag: constants.USERS_MANAGEMENT_ENABLED,
  },
  {
    path: `${BASE_ROUTE}network`,
    component: UserIsAuthenticated(NetworkModule),
    requiredFlag: constants.NETWORK_MONITOR_MODULE_ENABLED,
  },
  {
    path: `${BASE_ROUTE}last-mile`,
    component: UserIsAuthenticated(LastMileModule),
    requiredFlag: constants.LAST_MILE_MODULE_ENABLED,
  },
  {
    path: `${BASE_ROUTE}copilot`,
    component: UserIsAuthenticated(CopilotModule),
    requiredFlag: constants.COPILOT_TAB,
  },
  {
    path: `${BASE_ROUTE}pricing-console`,
    component: UserIsAuthenticated(PricingConsoleModule),
    requiredFlag: constants.PRICING_CONSOLE_MODULE_ENABLED,
  },
  {
    path: '*',
    component: UserIsAuthenticated(() => <></>),
  },
];
